import React, { useState, setState } from 'react'
import PersonIcon from '@mui/icons-material/Person';
import AccountCircleIcon from '@mui/icons-material/AccountCircle';
import './BDetails.css'
export default function BrandDetails() {
    const [brandName, setBrandName] = useState(undefined);
    const [gstNo, setGstNo] = useState(undefined);
    const [year, setYear] = useState(undefined);
    const [about, setAbout] = useState(undefined);
    const [influencerList, setInfluencerList] = useState([]);
    const handleInputChange = (e) => {
        const { id, value } = e.target;
        if (id === "brandName") {
            setBrandName(value);
        }
        if (id === "gstNo") {
            setGstNo(value);
        }
        if (id === "year") {
            setYear(value);
        }
        if (id === "about") {
            setAbout(value);
        }
        if (id === "b-btn") {
            setInfluencerList(influencerList.push(value));
        }
    }
    const handleSubmit = () => {
        console.log(brandName, gstNo, year, about, influencerList);
    }
    return (
        <div className='b-outerdiv'>
            <div className='b-middiv'>
            <h5>Welcome to Interra</h5>
            <h6>Please Fill The Following Details</h6>
            </div>
            <div className='b-innerDiv'>
                <div className='b-form d-flex flex-wrap'>
                    <div className="b-column2">
                        {/* <img src='/images/path7.png' alt='' className='i-user'></img> */}
                        <AccountCircleIcon className='user' sx={{ fontSize: 100,color:'#545e6d',background:'transparent' }}/>
                        <div className="b-brandname">
                            <PersonIcon className="b-icon1" />
                            <input className="b-inp" type="text" value={brandName} onChange={(e) => handleInputChange(e)} id="brandName" placeholder="Brand Name" />
                        </div>
                        <div className="gstNo">
                            <input type="text" id="gstNo" className="b-inp" value={gstNo} onChange={(e) => handleInputChange(e)} placeholder="GST number" />
                        </div>
                        <div className="b-year">
                            <input type="text" id="year" className="b-inp" value={year} onChange={(e) => handleInputChange(e)} placeholder="Year" />
                        </div>
                        <div className="b-about">
                            <PersonIcon className="b-icon1" />
                            <input type="textarea" id="about" className="b-inp" value={about} onChange={(e) => handleInputChange(e)} placeholder="About the brand" />
                        </div>
                    </div>
                    <div className='b-column2'>
                        <p className='p3'>Type of Brand</p>
                        <div className='b-opt'>
                            <button className='sbtn b-btn1' id='b-btn' onClick={(e) => handleInputChange(e)} value='Life Style'>Life Style</button>
                            <button className='sbtn b-btn2' id='b-btn' onClick={(e) => handleInputChange(e)} value='Food'>Food</button>
                            <button className='sbtn b-btn3' id='b-btn' onClick={(e) => handleInputChange(e)} value='Sports'>Sports</button>
                            <button className='sbtn b-btn4' id='b-btn' onClick={(e) => handleInputChange(e)} value='Health'>Health</button>
                            <button className='sbtn b-btn5' id='b-btn' onClick={(e) => handleInputChange(e)} value='Food'>Food</button>
                            <button className='sbtn b-btn6' id='b-btn' onClick={(e) => handleInputChange(e)} value='Finance'>Finance</button>
                            <button className='sbtn b-btn7' id='b-btn' onClick={(e) => handleInputChange(e)} value='Finance'>Finance</button>
                        </div>
                    </div>

                </div>
                <button onClick={() => handleSubmit()} type="submit" className="b-btn-submit" value='Continue'>
                    <a href='/pricing' className='brand-register'>Continue</a>
                </button>
            </div>
        </div>
    )
}